import React from 'react';
import Button from '@atlaskit/button/new';
import { useIntl } from '@atlassian/jira-intl';
import { expVal } from '@atlassian/jira-feature-experiments';
import type { IssueLinkType } from '@atlassian/jira-issue-shared-types/src/common/types/linked-issue-type.tsx';
import type { InvokedFrom, ResourceSuggestion } from '../../controllers/context.tsx';
import { LinkSplitButton } from '../link-split-button/index.tsx';
import messages from './messages.tsx';

type FooterProps = {
	suggestions: ResourceSuggestion[] | undefined;
	onAcceptAllSuggestions: () => void;
	onAcceptSelectedSuggestions: (issueLinkType: IssueLinkType) => void;
	invokedFrom: InvokedFrom;
	relatesToIssueLinkType: IssueLinkType | undefined;
	issueLinkTypes: IssueLinkType[];
	hasSelectedSuggestions: boolean;
};

export const Footer: React.FC<FooterProps> = ({
	suggestions,
	onAcceptAllSuggestions,
	onAcceptSelectedSuggestions,
	invokedFrom,
	hasSelectedSuggestions,
}) => {
	const { formatMessage } = useIntl();

	if (!suggestions || suggestions.length === 0) {
		return null;
	}

	// We don't show a CTA button in GIC
	if (
		invokedFrom === 'globalIssueCreate' &&
		expVal('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false)
	) {
		return null;
	}

	if (expVal('jira-ai-similar-issues-selectable-draft-list', 'isEnabled', false)) {
		return (
			<LinkSplitButton
				onButtonClick={onAcceptSelectedSuggestions}
				isButtonDisabled={!hasSelectedSuggestions}
				appearance="primary"
			/>
		);
	}

	return (
		<Button
			type="button"
			testId="ai-related-issues.ui.footer.accept-all-loading-button"
			onClick={onAcceptAllSuggestions}
			spacing="compact"
			appearance="primary"
		>
			{formatMessage(messages.linkAll)}
		</Button>
	);
};
